import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const DownArrowRight = createSvgIcon(
  <path d="M20.25 18.659 3.112 1.52l-1.59 1.591L18.658 20.25H3v2.25h19.5V3h-2.25v15.659Z" />,
  'DownArrowRight'
);

export { DownArrowRight };